import React, { useEffect, createElement } from 'react';
import { TrendingUpIcon, DollarSignIcon, UsersIcon } from 'lucide-react';
export function Results() {
  const videoTestimonials = [{
    id: '3cr3t5esqv',
    name: 'Testimonio 1'
  }, {
    id: 'ui7vp4u54s',
    name: 'Testimonio 2'
  }, {
    id: '1h6xcfjlz3',
    name: 'Testimonio 3'
  }, {
    id: 'y5kyufgdri',
    name: 'Testimonio 4'
  }];
  useEffect(() => {
    // Load Wistia player script
    const script1 = document.createElement('script');
    script1.src = 'https://fast.wistia.com/player.js';
    script1.async = true;
    document.head.appendChild(script1);
    // Load individual video scripts
    videoTestimonials.forEach(video => {
      const script = document.createElement('script');
      script.src = `https://fast.wistia.com/embed/${video.id}.js`;
      script.async = true;
      script.type = 'module';
      document.head.appendChild(script);
    });
    return () => {
      // Cleanup scripts on unmount
      const scripts = document.head.querySelectorAll('script[src*="wistia"]');
      scripts.forEach(script => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, []);
  return <section data-id="element-622">
      <style dangerouslySetInnerHTML={{
      __html: `
          wistia-player[media-id='3cr3t5esqv']:not(:defined) { 
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/3cr3t5esqv/swatch'); 
            display: block; 
            filter: blur(5px); 
            padding-top:177.78%; 
          }
          wistia-player[media-id='ui7vp4u54s']:not(:defined) { 
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/ui7vp4u54s/swatch'); 
            display: block; 
            filter: blur(5px); 
            padding-top:177.78%; 
          }
          wistia-player[media-id='1h6xcfjlz3']:not(:defined) { 
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/1h6xcfjlz3/swatch'); 
            display: block; 
            filter: blur(5px); 
            padding-top:177.78%; 
          }
          wistia-player[media-id='y5kyufgdri']:not(:defined) { 
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/y5kyufgdri/swatch'); 
            display: block; 
            filter: blur(5px); 
            padding-top:177.78%; 
          }
        `
    }} data-id="element-623" />
      <div className="bg-gray-800 bg-opacity-50 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-624">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-6 md:mb-8 text-center leading-tight" data-id="element-625">
          Resultados Reales de Mis Estudiantes
        </h2>
        <p className="text-lg md:text-xl text-center text-gray-300 mb-8 md:mb-10 leading-relaxed max-w-3xl mx-auto" data-id="element-626">
          Esto es lo que puedes lograr cuando implementas correctamente el
          sistema que te enseñaré:
        </p>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12 max-w-4xl mx-auto" data-id="element-627">
          <div className="bg-gradient-to-br from-green-900 to-green-800 bg-opacity-50 rounded-xl p-6 text-center" data-id="element-628">
            <TrendingUpIcon className="h-10 w-10 text-green-400 mx-auto mb-3" data-id="element-629" />
            <div className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-630">
              $500M+
            </div>
            <div className="text-sm text-gray-300" data-id="element-631">
              Generados por estudiantes
            </div>
          </div>
          <div className="bg-gradient-to-br from-blue-900 to-blue-800 bg-opacity-50 rounded-xl p-6 text-center" data-id="element-632">
            <UsersIcon className="h-10 w-10 text-blue-400 mx-auto mb-3" data-id="element-633" />
            <div className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-634">
              5,000+
            </div>
            <div className="text-sm text-gray-300" data-id="element-635">Estudiantes activos</div>
          </div>
          <div className="bg-gradient-to-br from-purple-900 to-purple-800 bg-opacity-50 rounded-xl p-6 text-center" data-id="element-636">
            <DollarSignIcon className="h-10 w-10 text-purple-400 mx-auto mb-3" data-id="element-637" />
            <div className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-638">
              $8.5K
            </div>
            <div className="text-sm text-gray-300" data-id="element-639">Promedio primer mes</div>
          </div>
        </div>

        {/* Main Result Image */}
        <div className="max-w-2xl mx-auto mb-12" data-id="element-640">
          <div className="relative rounded-xl md:rounded-2xl overflow-hidden shadow-2xl" data-id="element-641">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iDfM4d2o3TiJ8yUUGm66kX/IMG_1139.jpg" alt="Shopify orders showing real results" className="w-full h-auto" data-id="element-642" />
          </div>
          <div className="mt-6 md:mt-8 text-center" data-id="element-643">
            <p className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-644">
              Ventas automáticas de productos digitales generando ingresos
              mientras duermes
            </p>
          </div>
        </div>

        {/* Video Testimonials */}
        <div className="mb-8" data-id="element-645">
          <h3 className="text-xl md:text-2xl font-bold text-center text-white mb-8" data-id="element-646">
            Escucha lo que dicen nuestros estudiantes
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-6xl mx-auto" data-id="element-647">
            {videoTestimonials.map(video => <div key={video.id} className="bg-gray-900 bg-opacity-50 rounded-xl overflow-hidden border border-gray-700" data-id="element-648">
                <div className="aspect-[9/16]" data-id="element-649">
                  <wistia-player media-id={video.id} aspect="0.5625" data-id="element-650"></wistia-player>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}